import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import ihelmEN from './locales/en/ihelm.json';
import cetafuelEN from './locales/en/cetafuel.json';
import solutionsEN from './locales/en/solutions.json';
import aboutEN from './locales/en/about.json';
import contactEN from './locales/en/contact.json';
import careersEN from './locales/en/careers.json';
import innovationEN from './locales/en/innovation.json';
import segmentsEN from './locales/en/segments.json';
import blogEN from './locales/en/blog.json';
import legalEN from './locales/en/legal.json';

import commonSV from './locales/sv/common.json';
import homeSV from './locales/sv/home.json';
import ihelmSV from './locales/sv/ihelm.json';
import cetafuelSV from './locales/sv/cetafuel.json';
import solutionsSV from './locales/sv/solutions.json';
import aboutSV from './locales/sv/about.json';
import contactSV from './locales/sv/contact.json';
import careersSV from './locales/sv/careers.json';
import innovationSV from './locales/sv/innovation.json';
import segmentsSV from './locales/sv/segments.json';
import blogSV from './locales/sv/blog.json';
import legalSV from './locales/sv/legal.json';

import commonJA from './locales/ja/common.json';
import homeJA from './locales/ja/home.json';
import ihelmJA from './locales/ja/ihelm.json';
import cetafuelJA from './locales/ja/cetafuel.json';
import solutionsJA from './locales/ja/solutions.json';
import aboutJA from './locales/ja/about.json';
import contactJA from './locales/ja/contact.json';
import careersJA from './locales/ja/careers.json';
import innovationJA from './locales/ja/innovation.json';
import segmentsJA from './locales/ja/segments.json';
import blogJA from './locales/ja/blog.json';
import legalJA from './locales/ja/legal.json';

import commonZH from './locales/zh/common.json';
import homeZH from './locales/zh/home.json';
import ihelmZH from './locales/zh/ihelm.json';
import cetafuelZH from './locales/zh/cetafuel.json';
import solutionsZH from './locales/zh/solutions.json';
import aboutZH from './locales/zh/about.json';
import contactZH from './locales/zh/contact.json';
import careersZH from './locales/zh/careers.json';
import innovationZH from './locales/zh/innovation.json';
import segmentsZH from './locales/zh/segments.json';
import blogZH from './locales/zh/blog.json';
import legalZH from './locales/zh/legal.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEN,
        home: homeEN,
        ihelm: ihelmEN,
        cetafuel: cetafuelEN,
        solutions: solutionsEN,
        about: aboutEN,
        contact: contactEN,
        careers: careersEN,
        innovation: innovationEN,
        segments: segmentsEN,
        blog: blogEN,
        legal: legalEN,
      },
      sv: {
        common: commonSV,
        home: homeSV,
        ihelm: ihelmSV,
        cetafuel: cetafuelSV,
        solutions: solutionsSV,
        about: aboutSV,
        contact: contactSV,
        careers: careersSV,
        innovation: innovationSV,
        segments: segmentsSV,
        blog: blogSV,
        legal: legalSV,
      },
      ja: {
        common: commonJA,
        home: homeJA,
        ihelm: ihelmJA,
        cetafuel: cetafuelJA,
        solutions: solutionsJA,
        about: aboutJA,
        contact: contactJA,
        careers: careersJA,
        innovation: innovationJA,
        segments: segmentsJA,
        blog: blogJA,
        legal: legalJA,
      },
      zh: {
        common: commonZH,
        home: homeZH,
        ihelm: ihelmZH,
        cetafuel: cetafuelZH,
        solutions: solutionsZH,
        about: aboutZH,
        contact: contactZH,
        careers: careersZH,
        innovation: innovationZH,
        segments: segmentsZH,
        blog: blogZH,
        legal: legalZH,
      },
    },
    supportedLngs: ['en', 'sv', 'ja', 'zh'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'ihelm', 'cetafuel', 'solutions', 'about', 'contact', 'careers', 'innovation', 'segments', 'blog', 'legal'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'cetasol-lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
